// vzhlad_predajne_v2 (20. 10. 2026, ústava 61.10): starý oranžový panel/akcent nahradený hodnotami témy — 1 miest
// DochadzkaView.jsx — DOCHÁDZKA HODINOVKÁROV, pohľad OFFICE (Mirko GO 2026-08-03, ústava 121)
// Štýl = zošit Mzdy 2026 (MasterDetail + KPI + tabuľka, uppercase hlavičky, žiadne emoji).
//
// ČO TU OFFICE ROBÍ:
//   • vidí napichané hodiny per osoba, rozpadnuté PO ZÁKAZKÁCH (vždy sa účtuje pre zákazku — ústava),
//   • opraví čas alebo uzná iný počet hodín — napichané ostáva viditeľné vedľa uznaného (dôkaz pri spore),
//   • zaškrtne JEDNOTLIVÉ DNI alebo CELÚ ZÁKAZKU a vyúčtuje ich do mzdy,
//   • vidí, odkiaľ sa pichlo (GPS), či to pichol predák za kolegu a koľko fotiek k tomu je.
// 🔴 Vyúčtovaný úsek je zamknutý — zámok je NA RIADKU, nie plošne (poučenie zo súpisu výmer, ústava 21.20.A).
import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { useDirtyFlag } from '../hooks/useDirtyState.js'   // straz_v3 (28. 9. 2026): rozpísaná oprava dochádzky drží stráž odchodu (ústava 53.1.b)
import { COLORS, TYPO, SPACE, RADIUS, TINT, todayLocal, hladaj } from '../theme.js'
import { PageHeader, MasterDetail, ListRow, ListStatusBar, Sekcia, TeloKarty, EmptyPane, SearchInput, SearchableSelect } from '../components/Ui.jsx'
import { Modal } from '../components/Modal.jsx'
import { useListKeyboard } from '../hooks/useListKeyboard.js'
import { Btn, BtnAdd, BtnGhost } from '../components/Btn.jsx'
import RowMenu from '../components/RowMenu.jsx'
import { useToast } from '../components/Toast.jsx'
import { useConfirm } from '../components/ConfirmDialog.jsx'
import { fetchAuth } from '../auth/fetchAuth.js'
import useLiveRefresh from '../hooks/useLiveRefresh.js'

const API = '/api/dochadzka'
const fmtD = (d) => { const p = String(d || '').slice(0, 10).split('-'); return p.length === 3 ? `${p[2]}.${p[1]}.` : (d || '') }
const hod = (n) => (Math.round((Number(n) || 0) * 100) / 100).toLocaleString('sk-SK', { minimumFractionDigits: 2 }) + ' h'
const DEN = ['nedeľa', 'pondelok', 'utorok', 'streda', 'štvrtok', 'piatok', 'sobota']
const denVTyzdni = (d) => { try { return DEN[new Date(d + 'T00:00:00').getDay()] } catch (_) { return '' } }
// dochadzka_polnoc_v1: JEDNA farba pre úsek, ktorý zastavil Matrix (61.10 — pozor: #B45309 na #FEF3C7)
const POLNOC_BG = '#FEF3C7'
const POLNOC_FG = '#B45309'
const inpSm = { padding: '3px 6px', fontSize: TYPO.sizes.sm, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontFamily: 'inherit', width: 66, textAlign: 'right', boxSizing: 'border-box' }

// Obdobia — office účtuje týždeň, dvojtýždeň alebo mesiac
function obdobia() {
  const d = new Date(); const den = (d.getDay() + 6) % 7            // pondelok = 0
  const pon = new Date(d); pon.setDate(d.getDate() - den)
  const iso = (x) => x.toISOString().slice(0, 10)
  const minPon = new Date(pon); minPon.setDate(pon.getDate() - 7)
  const dvojPon = new Date(pon); dvojPon.setDate(pon.getDate() - 7)
  const prvy = new Date(d.getFullYear(), d.getMonth(), 1)
  return [
    { key: 'tyzden', label: 'Tento týždeň', od: iso(pon), do: iso(d) },
    { key: 'minuly', label: 'Minulý týždeň', od: iso(minPon), do: iso(new Date(pon.getTime() - 864e5)) },
    { key: 'dvoj', label: 'Dvojtýždeň', od: iso(dvojPon), do: iso(d) },
    { key: 'mesiac', label: 'Tento mesiac', od: iso(prvy), do: iso(d) },
  ]
}

export default function DochadzkaView() {
  const toast = useToast()
  const confirm = useConfirm()
  const OBD = useMemo(() => obdobia(), [])
  const [obd, setObd] = useState('tyzden')
  const akt = OBD.find(o => o.key === obd) || OBD[0]
  const [od, setOd] = useState(akt.od)
  const [doo, setDoo] = useState(akt.do)
  const [ludia, setLudia] = useState([])
  const [rows, setRows] = useState([])
  const [sel, setSel] = useState(null)          // employee_id
  const [q, setQ] = useState('')          // dochadzka_hladat_v1: stav sa volal hladaj a tienil funkciu hladaj z theme.js (biela obrazovka)
  const [check, setCheck] = useState({})        // id -> true
  const [editId, setEditId] = useState(null)
  const [draft, setDraft] = useState({})
  // straz_v3: rozpísaná oprava času → prepnutie človeka, záložky alebo modulu sa spýta; Uložiť = tá istá oprava ako tlačidlom pri riadku
  useDirtyFlag(!!editId, { key: 'dochadzka-oprava', save: async () => { const r = mojeRiadky.find(x => x.id === editId); return r ? ulozOpravu(r) : false }, discard: () => setEditId(null) })
  const [loading, setLoading] = useState(true)
  const [projekty, setProjekty] = useState([])
  const [rucny, setRucny] = useState(null)      // { employee_id, date, project_id, start_at, end_at, lunch_od, lunch_do, note }
  const [polohy, setPolohy] = useState(null)    // dochadzka_polnoc_v1: { date, meno } — okno so zmenami polohy za deň

  const zvolObdobie = (k) => { const o = OBD.find(x => x.key === k); if (!o) return; setObd(k); setOd(o.od); setDoo(o.do) }

  const load = useCallback(async () => {
    setLoading(true)
    try {
      const [rep, hodin] = await Promise.all([
        fetchAuth(`${API}/report?od=${od}&do=${doo}`).then(r => r.ok ? r.json() : { osoby: [], riadky: [] }),
        fetchAuth(`${API}/hodinovkari`).then(r => r.ok ? r.json() : []),
      ])
      const per = {}; (rep.osoby || []).forEach(o => { per[o.employee_id] = o })
      setLudia((Array.isArray(hodin) ? hodin : []).map(h => ({ ...h, ...(per[h.id] || { hodiny: 0, dni: 0 }) })))
      setRows(Array.isArray(rep.riadky) ? rep.riadky : [])
    } catch (_) { toast.error('Dochádzka sa nenačítala.') }
    finally { setLoading(false) }
  }, [od, doo, toast])
  useEffect(() => { load() }, [load])
  useEffect(() => { fetchAuth('/api/projects').then(r => r.ok ? r.json() : []).then(d => setProjekty(Array.isArray(d) ? d : [])).catch(() => {}) }, [])
  useLiveRefresh(load, () => !loading)

  const mojeRiadky = useMemo(() => rows.filter(r => r.employee_id === sel), [rows, sel])
  const otvorene = useMemo(() => mojeRiadky.filter(r => !r.vyuctovane), [mojeRiadky])
  const vybrane = useMemo(() => Object.keys(check).filter(k => check[k]), [check])
  const sumaVybranych = useMemo(
    () => mojeRiadky.filter(r => check[r.id]).reduce((a, r) => a + Number(r.hodiny_platne || 0), 0), [mojeRiadky, check])

  // zoskupenie podľa zákazky — office účtuje po zákazkách
  const podlaZakazky = useMemo(() => {
    const m = {}
    otvorene.forEach(r => {
      const k = r.project_id || '—'
      m[k] = m[k] || { project_id: r.project_id, nazov: r.project_name || '(bez zákazky)', hodiny: 0, ids: [] }
      m[k].hodiny += Number(r.hodiny_platne || 0); m[k].ids.push(r.id)
    })
    return Object.values(m)
  }, [otvorene])

  const ludiaF = useMemo(() => {
    return ludia.filter(l => hladaj((l.meno || ''), q))
      .sort((a, b) => (b.hodiny || 0) - (a.hodiny || 0) || (a.meno || '').localeCompare(b.meno || '', 'sk'))
  }, [ludia, q])

  useListKeyboard({ items: ludiaF, selectedId: sel, onSelect: (id) => { setSel(id); setCheck({}) }, enabled: !rucny && !editId })

  const kpi = useMemo(() => ({
    hodiny: rows.reduce((a, r) => a + Number(r.hodiny_platne || 0), 0),
    naVyuct: rows.filter(r => !r.vyuctovane).reduce((a, r) => a + Number(r.hodiny_platne || 0), 0),
    ludia: new Set(rows.map(r => r.employee_id)).size,
  }), [rows])

  const oznacZakazku = (z) => setCheck(c => {
    const vsetky = z.ids.every(id => c[id]); const n = { ...c }
    z.ids.forEach(id => { if (vsetky) delete n[id]; else n[id] = true }); return n
  })

  const vyuctuj = async () => {
    if (!vybrane.length) { toast.error('Zaškrtni dni alebo zákazku, ktoré chceš vyúčtovať.'); return }
    const ok = await confirm({
      title: 'Vyúčtovať vybrané?',
      message: `Vyúčtuje sa ${vybrane.length} úsekov (${hod(sumaVybranych)}). Hodinovkárovi vznikne v zošite Mzdy 2026 riadok nárok za každý úsek (hodiny × sadzba z karty zamestnanca); úkolovému sa úsek len označí, do mzdy nejde. Vyúčtované úseky sa zamknú — zrušiť ich môže office, kým nie je blok zošita uzavretý. Ostatné dni zostanú otvorené.`,
      confirmLabel: 'Vyúčtovať',
    })
    if (!ok) return
    try {
      const r = await fetchAuth(`${API}/vyuctovanie`, { method: 'POST', body: JSON.stringify({ ids: vybrane, ym: String(doo).slice(0, 7) }) })
      const j = await r.json(); if (!r.ok) throw new Error(j.error || 'Zlyhalo')
      toast.success(`Vyúčtovaných ${j.vyuctovanych} úsekov do ${j.ym}` + (j.mzda_riadkov ? `, do zošita Mzdy ${j.mzda_riadkov} riadkov (${hod(j.hodin || 0)})` : '') + (j.orientacne ? `, ${j.orientacne} len orientačne (úkol)` : '') + (j.bez_sadzby ? ` — POZOR: ${j.bez_sadzby} bez sadzby na karte, suma 0` : '') + '.')
      setCheck({}); load()
    } catch (e) { toast.error('Nepodarilo sa: ' + e.message, { duration: 12000 }) }
  }

  const zrusVyuctovanie = async (r) => {
    const ok = await confirm({ title: 'Zrušiť vyúčtovanie?', message: `Úsek ${fmtD(r.date)} · ${r.project_name || ''} sa vráti medzi otvorené a bude sa dať znova upraviť. Zapíše sa to do auditu.`, confirmLabel: 'Zrušiť vyúčtovanie' })
    if (!ok) return
    try {
      const x = await fetchAuth(`${API}/vyuctovanie/zrusit`, { method: 'POST', body: JSON.stringify({ ids: [r.id] }) })
      if (!x.ok) throw new Error('HTTP ' + x.status)
      toast.success('Vyúčtovanie zrušené.'); load()
    } catch (e) { toast.error('Nepodarilo sa: ' + e.message) }
  }

  const ulozOpravu = async (r) => {
    try {
      const b = { start_at: draft.start_at, end_at: draft.end_at, lunch_od: draft.lunch_od, lunch_do: draft.lunch_do,
        hodiny_uznane: draft.hodiny_uznane === '' ? null : draft.hodiny_uznane, note: draft.note }
      const x = await fetchAuth(`${API}/${r.id}`, { method: 'PUT', body: JSON.stringify(b) })
      const j = await x.json(); if (!x.ok) throw new Error(j.message || j.error || 'Zlyhalo')
      toast.success('Opravené. Napichaný čas ostáva uložený.'); setEditId(null); load(); return true
    } catch (e) { toast.error('Nepodarilo sa: ' + e.message); return false }   // straz_v3: true/false pre stráž
  }

  const otvorRucny = (empId) => setRucny({
    employee_id: empId || sel, date: todayLocal(),
    project_id: '', start_at: '07:00', end_at: '15:30', lunch_od: '11:30', lunch_do: '12:00', note: '',
  })
  const ulozRucny = async () => {
    if (!rucny.employee_id) { toast.error('Vyber človeka.'); return }
    if (!rucny.project_id) { toast.error('Vyber zákazku — dochádzka sa vždy eviduje na zákazku.'); return }
    try {
      const r = await fetchAuth(API, { method: 'POST', body: JSON.stringify(rucny) })
      const j = await r.json(); if (!r.ok) throw new Error(j.error || 'Zlyhalo')
      toast.success('Deň zapísaný. Je označený ako ručný zápis — nemá GPS.')
      setRucny(null); if (!sel) setSel(rucny.employee_id); load()
    } catch (e) { toast.error('Nepodarilo sa: ' + e.message) }
  }

  // Tlač podkladu pre mzdu — to, čo office naozaj potrebuje vytlačiť a založiť
  const tlac = (empId) => {
    const l = ludia.find(x => x.id === empId) || {}
    const rs = rows.filter(r => r.employee_id === empId)
    if (!rs.length) { toast.error('V tomto období nemá žiadnu dochádzku.'); return }
    const spolu = rs.reduce((a, r) => a + Number(r.hodiny_platne || 0), 0)
    const w = window.open('', '_blank'); if (!w) { toast.info('Povoľ pop-up okná pre tlač.'); return }
    w.document.write(`<!doctype html><meta charset="utf-8"><title>Dochádzka ${l.meno || ''}</title>
      <style>body{font:13px/1.5 -apple-system,Segoe UI,Roboto,sans-serif;padding:24px;color:#1b1714}
      h1{font-size:19px;margin:0 0 2px}.sub{color:#666;margin-bottom:16px;font-size:12.5px}
      table{width:100%;border-collapse:collapse}th{font-size:10.5px;text-transform:uppercase;letter-spacing:.05em;
      color:#666;text-align:left;border-bottom:1px solid #ccc;padding:5px 7px}
      td{padding:5px 7px;border-bottom:1px solid #eee;vertical-align:top}
      .r{text-align:right;font-variant-numeric:tabular-nums}tfoot td{font-weight:700;border-top:2px solid #333}</style>
      <h1>Dochádzka — ${l.meno || ''}</h1>
      <div class="sub">Obdobie ${fmtD(od)} – ${fmtD(doo)} · podklad pre mzdu · vytlačené ${new Date().toLocaleDateString('sk-SK')}</div>
      <table><thead><tr><th>Dátum</th><th>Zákazka</th><th>Od</th><th>Do</th><th>Obed</th>
      <th class="r">Napichané</th><th class="r">Uznané</th><th>Popis</th><th>Stav</th></tr></thead><tbody>
      ${rs.map(r => `<tr><td>${fmtD(r.date)} ${denVTyzdni(r.date)}</td><td>${r.project_name || '—'}</td>
        <td>${r.start_at || '—'}</td><td>${r.end_at || '—'}</td><td>${r.lunch_od ? r.lunch_od + '–' + (r.lunch_do || '') : '—'}</td>
        <td class="r">${hod(r.hodiny)}</td><td class="r">${hod(r.hodiny_platne)}</td>
        <td>${(r.note || r.praca || '').replace(/</g, '&lt;')}${r.rucne ? ' <i>(ručne)</i>' : ''}${r.za_kolegu ? ' <i>(pichol ' + (r.punched_by || 'predák') + ')</i>' : ''}</td>
        <td>${r.vyuctovane ? 'vyúčtované ' + r.vyuctovane_ym : 'otvorené'}</td></tr>`).join('')}
      </tbody><tfoot><tr><td colspan="6">Spolu</td><td class="r">${hod(spolu)}</td><td colspan="2"></td></tr></tfoot></table>`)
    w.document.close(); w.focus(); setTimeout(() => { try { w.print() } catch (_) {} }, 250)
  }

  const mapa = (r) => r.start_lat ? `https://maps.google.com/?q=${r.start_lat},${r.start_lng}` : ''

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', gap: SPACE.md }}>
      {/* dochadzka_plocha_v1 (61.10): jeden rad nad prácou — obdobie, dátumy a súčty namiesto troch KPI kariet */}
      <PageHeader title="Dochádzka" subtitle="Hodinovkári — hodiny, oprava a vyúčtovanie po zákazkách">
        <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexWrap: 'wrap' }}>
          {OBD.map(o => (
            <button key={o.key} type="button" onClick={() => zvolObdobie(o.key)} title={`${fmtD(o.od)} – ${fmtD(o.do)}`} style={{
              padding: '4px 12px', borderRadius: 16, cursor: 'pointer', fontFamily: 'inherit',
              fontSize: TYPO.sizes.sm, fontWeight: obd === o.key ? TYPO.weights.semibold : TYPO.weights.normal,
              border: `1px solid ${obd === o.key ? COLORS.nav : COLORS.line}`,
              background: obd === o.key ? COLORS.nav : COLORS.bg, color: obd === o.key ? '#fff' : COLORS.text,
              whiteSpace: 'nowrap',
            }}>{o.label}</button>
          ))}
          <input type="date" aria-label="od" value={od} onChange={e => { setOd(e.target.value); setObd('') }} style={{ ...inpSm, width: 130, textAlign: 'left' }} />
          <input type="date" aria-label="do" value={doo} onChange={e => { setDoo(e.target.value); setObd('') }} style={{ ...inpSm, width: 130, textAlign: 'left' }} />
          <span style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted, whiteSpace: 'nowrap' }}>
            {kpi.ludia} ľudí · <span style={{ color: COLORS.text, fontFamily: TYPO.mono, fontWeight: TYPO.weights.bold }}>{hod(kpi.hodiny)}</span>
            {kpi.naVyuct > 0 && <> · na vyúčtovanie <span style={{ color: COLORS.nav, fontFamily: TYPO.mono, fontWeight: TYPO.weights.bold }}>{hod(kpi.naVyuct)}</span></>}
          </span>
        </div>
      </PageHeader>

      <MasterDetail left={
        <>
          <div style={{ padding: SPACE.sm }}><SearchInput value={q} onChange={setQ} placeholder="Hľadať (stlač /)…" /></div>
          <div style={{ flex: 1, overflow: 'auto', padding: 6 }}>
            {loading ? <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>Načítavam…</div>
              : ludiaF.length === 0 ? <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>Žiadni hodinovkári.</div>
              : ludiaF.map(l => (
                <ListRow key={l.id} dataId={l.id} selected={sel === l.id} stripColor={l.hodiny ? COLORS.add : COLORS.line}
                  onClick={() => { setSel(l.id); setCheck({}) }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8, alignItems: 'center' }}>
                    <div style={{ minWidth: 0 }}>
                      <div style={{ fontWeight: TYPO.weights.semibold }}>{l.meno}</div>
                      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontFamily: TYPO.mono }}>{l.dni || 0} dní · {hod(l.hodiny || 0)}</div>
                    </div>
                    <RowMenu actions={[
                      { label: 'Zobraziť dni', onClick: () => { setSel(l.id); setCheck({}) } },
                      { label: 'Pridať deň ručne', onClick: () => { setSel(l.id); otvorRucny(l.id) } },
                      { separator: true },
                      { label: 'Označiť všetko otvorené', onClick: () => { setSel(l.id);
                          setCheck(rows.filter(r => r.employee_id === l.id && !r.vyuctovane).reduce((a, r) => (a[r.id] = true, a), {})) } },
                      { label: 'Tlačiť podklad', onClick: () => tlac(l.id) },
                    ]} />
                  </div>
                </ListRow>
              ))}
          </div>
          <ListStatusBar>{ludiaF.length} ľudí · ↑↓ výber · obdobie {fmtD(od)}–{fmtD(doo)}</ListStatusBar>
        </>
      } right={
        !sel ? <EmptyPane text="Vyber človeka vľavo — uvidíš jeho dni a budeš ich môcť vyúčtovať." /> : (
          <TeloKarty>
            {/* dochadzka_plocha_v1: hlavička karty je jeden tenký rad, bez oranžovej (61.10) */}
            <Sekcia ploche style={{ padding: `8px 14px` }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: SPACE.md, flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', alignItems: 'baseline', gap: SPACE.sm, flexWrap: 'wrap', minWidth: 0 }}>
                  <span style={{ fontWeight: TYPO.weights.bold, fontSize: TYPO.sizes.lg }}>{(ludia.find(l => l.id === sel) || {}).meno}</span>
                  <span style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted }}>
                    {fmtD(od)} – {fmtD(doo)} · otvorené <span style={{ fontFamily: TYPO.mono }}>{hod(otvorene.reduce((a, r) => a + Number(r.hodiny_platne || 0), 0))}</span>
                  </span>
                </div>
                <div style={{ display: 'flex', gap: SPACE.sm, flexWrap: 'wrap' }}>
                  <Btn variant="nav" onClick={() => otvorRucny(sel)}>Pridať deň ručne</Btn>
                  <BtnAdd onClick={vyuctuj} disabled={!vybrane.length}>
                    {vybrane.length ? `Vyúčtovať vybrané (${hod(sumaVybranych)})` : 'Vyúčtovať vybrané'}
                  </BtnAdd>
                </div>
              </div>
            </Sekcia>

            {/* rýchly výber celej zákazky */}
            {podlaZakazky.length > 0 && (
              <Sekcia nazov="Označiť celú zákazku" pocet={podlaZakazky.length}
                napoveda="Jedným klikom označíš všetky otvorené dni na tej zákazke. Vyúčtuje sa vždy pre zákazku — tak sa hodiny dostanú k správnej stavbe.">
                <div style={{ display: 'flex', gap: SPACE.sm, flexWrap: 'wrap' }}>
                  {podlaZakazky.map(z => {
                    const on = z.ids.every(id => check[id])
                    return (
                      <button key={z.project_id || '—'} type="button" onClick={() => oznacZakazku(z)} style={{
                        padding: '7px 13px', borderRadius: RADIUS.md, cursor: 'pointer', fontFamily: 'inherit',
                        fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold, textAlign: 'left',
                        border: `1px solid ${on ? COLORS.add : COLORS.line}`, background: on ? TINT.add || 'rgba(34,197,94,.10)' : COLORS.bg, color: COLORS.text,
                      }}>{z.nazov}<span style={{ color: COLORS.muted, fontWeight: 400 }}> · {hod(z.hodiny)}</span></button>
                    )
                  })}
                </div>
              </Sekcia>
            )}

            {/* zošit dní */}
            <Sekcia nazov="Dni a hodiny" pocet={mojeRiadky.length}
              napoveda="Napichané hodiny ostávajú uložené aj po oprave — pri spore je vidno oboje. Vyúčtovaný úsek je zamknutý, ale ostatné dni a zákazky toho istého človeka sa meniť dajú. Každá zmena má v audite meno a dátum."
              style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
                <thead><tr style={{ background: COLORS.bgSoft }}>
                  {['', 'Dátum', 'Zákazka', 'Od', 'Do', 'Obed', 'Napichané', 'Uznané', 'Popis', 'Kde / kto', 'Stav', ''].map((h, i) =>
                    <th key={i} style={{ fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '.05em', color: COLORS.muted,
                      textAlign: i >= 6 && i <= 7 ? 'right' : 'left', padding: '5px 8px', borderBottom: `1px solid ${COLORS.line}`, whiteSpace: 'nowrap' }}>{h}</th>)}
                </tr></thead>
                <tbody>
                  {mojeRiadky.length === 0 && (
                    <tr><td colSpan={12} style={{ padding: SPACE.lg, color: COLORS.muted }}>V tomto období nemá žiadnu dochádzku. Deň môžeš zapísať tlačidlom „Pridať deň ručne“.</td></tr>
                  )}
                  {mojeRiadky.map(r => {
                    const zamk = !!r.vyuctovane
                    // dochadzka_polnoc_v1 (Mirko 21. 10.): úsek, ktorý zastavil Matrix o polnoci, má JEDNU farbu (61.10 pozor)
                    const polnoc = !!r.polnoc
                    const td = { padding: '5px 8px', borderBottom: `1px solid ${COLORS.lineSoft}`, verticalAlign: 'top',
                      background: polnoc ? POLNOC_BG : (zamk ? (TINT.nav || 'rgba(0,0,0,.02)') : 'transparent') }
                    if (editId === r.id) return (
                      <tr key={r.id}>
                        <td style={td} />
                        <td style={td}>{fmtD(r.date)}</td>
                        <td style={td}>{r.project_name || '—'}</td>
                        <td style={td}><input style={{ ...inpSm, width: 58, textAlign: 'left' }} value={draft.start_at || ''} onChange={e => setDraft(d => ({ ...d, start_at: e.target.value }))} /></td>
                        <td style={td}><input style={{ ...inpSm, width: 58, textAlign: 'left' }} value={draft.end_at || ''} onChange={e => setDraft(d => ({ ...d, end_at: e.target.value }))} /></td>
                        <td style={td}>
                          <input style={{ ...inpSm, width: 52, textAlign: 'left' }} value={draft.lunch_od || ''} onChange={e => setDraft(d => ({ ...d, lunch_od: e.target.value }))} />
                          <input style={{ ...inpSm, width: 52, textAlign: 'left', marginLeft: 3 }} value={draft.lunch_do || ''} onChange={e => setDraft(d => ({ ...d, lunch_do: e.target.value }))} />
                        </td>
                        <td style={{ ...td, textAlign: 'right', fontFamily: TYPO.mono }}>{hod(r.hodiny)}</td>
                        <td style={{ ...td, textAlign: 'right' }}>
                          <input style={inpSm} placeholder="ako napichané" value={draft.hodiny_uznane ?? ''} onChange={e => setDraft(d => ({ ...d, hodiny_uznane: e.target.value }))} />
                        </td>
                        <td style={td} colSpan={2}><input style={{ ...inpSm, width: '100%', textAlign: 'left' }} placeholder="poznámka k oprave" value={draft.note || ''} onChange={e => setDraft(d => ({ ...d, note: e.target.value }))} /></td>
                        <td style={{ ...td, whiteSpace: 'nowrap' }}>
                          <Btn variant="add" onClick={() => ulozOpravu(r)}>Uložiť</Btn>{' '}
                          <BtnGhost onClick={() => setEditId(null)}>Späť</BtnGhost>
                        </td>
                      </tr>
                    )
                    return (
                      <tr key={r.id}>
                        <td style={td}>
                          <input type="checkbox" disabled={zamk} checked={!!check[r.id]}
                            onChange={e => setCheck(c => { const n = { ...c }; if (e.target.checked) n[r.id] = true; else delete n[r.id]; return n })} />
                        </td>
                        <td style={{ ...td, whiteSpace: 'nowrap' }}>
                          <div style={{ fontWeight: TYPO.weights.semibold }}>{fmtD(r.date)}</div>
                          <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{denVTyzdni(r.date)}</div>
                        </td>
                        <td style={td}>{r.project_name || <span style={{ color: COLORS.remove }}>bez zákazky</span>}</td>
                        <td style={{ ...td, fontFamily: TYPO.mono }}>{r.start_at || '—'}</td>
                        <td style={{ ...td, fontFamily: TYPO.mono }}>{r.end_at || <span style={{ color: COLORS.warn }}>beží</span>}</td>
                        <td style={{ ...td, fontFamily: TYPO.mono, color: COLORS.muted }}>{r.lunch_od ? `${r.lunch_od}–${r.lunch_do || ''}` : '—'}</td>
                        <td style={{ ...td, textAlign: 'right', fontFamily: TYPO.mono }}>{hod(r.hodiny)}</td>
                        <td style={{ ...td, textAlign: 'right', fontFamily: TYPO.mono, fontWeight: TYPO.weights.bold,
                          color: r.upravene_office ? COLORS.brand : COLORS.text }}>
                          {hod(r.hodiny_platne)}
                          {r.upravene_office && <div style={{ fontSize: 10, color: COLORS.muted, fontWeight: 400 }}>upravil office</div>}
                        </td>
                        <td style={{ ...td, maxWidth: 220 }}>
                          {(r.note || r.praca)
                            ? <span style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>{r.note || r.praca}</span>
                            : <span style={{ color: COLORS.muted }}>—</span>}
                        </td>
                        <td style={td}>
                          {mapa(r) && <a href={mapa(r)} target="_blank" rel="noreferrer" style={{ color: COLORS.nav, fontSize: TYPO.sizes.xs }}>poloha</a>}
                          {r.za_kolegu === 1 && <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.brand }}>pichol {r.punched_by || 'predák'}</div>}
                          {r.rucne && <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.warn }}>ručný zápis · bez GPS</div>}
                          {(r.fotky || []).length > 0 && <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{r.fotky.length} foto</div>}
                        </td>
                        <td style={td}>
                          {zamk
                            ? <span style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: COLORS.nav, background: TINT.nav, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, padding: '1px 6px', whiteSpace: 'nowrap' }}>vyúčtované {r.vyuctovane_ym}</span>
                            : polnoc
                            ? <span title="Človek sa neodpichol. Matrix úsek zastavil o polnoci a uznané hodiny dal na nulu — skutočný koniec doplň ty."
                                style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: POLNOC_FG, background: POLNOC_BG, border: `1px solid ${POLNOC_FG}`, borderRadius: RADIUS.sm, padding: '1px 6px', whiteSpace: 'nowrap' }}>zastavené o polnoci</span>
                            : <span style={{ fontSize: 10, fontWeight: 700, textTransform: 'uppercase', color: COLORS.muted }}>otvorené</span>}
                        </td>
                        <td style={{ ...td, textAlign: 'right' }}>
                          <RowMenu actions={[
                            ...(zamk ? [] : [
                              { label: 'Opraviť čas', onClick: () => { setEditId(r.id); setDraft({ start_at: r.start_at, end_at: r.end_at, lunch_od: r.lunch_od, lunch_do: r.lunch_do, hodiny_uznane: r.hodiny_uznane ?? '', note: r.note || '' }) } },
                              { label: r.note ? 'Upraviť popis' : 'Pridať popis', onClick: () => { setEditId(r.id); setDraft({ start_at: r.start_at, end_at: r.end_at, lunch_od: r.lunch_od, lunch_do: r.lunch_do, hodiny_uznane: r.hodiny_uznane ?? '', note: r.note || '' }) } },
                            ]),
                            ...(mapa(r) ? [{ label: 'Poloha na mape', onClick: () => window.open(mapa(r), '_blank') }] : []),
                            { label: 'Kedy sa zmenila poloha', onClick: () => setPolohy({ date: r.date, meno: (ludia.find(l => l.id === r.employee_id) || {}).meno }) },
                            { label: 'Tlačiť podklad', onClick: () => tlac(r.employee_id) },
                            ...(zamk ? [{ separator: true }, { label: 'Zrušiť vyúčtovanie', onClick: () => zrusVyuctovanie(r), danger: true }] : []),
                          ]} />
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </Sekcia>
          </TeloKarty>
        )
      } />

      {/* KEDY SA ZMENILA POLOHA (dochadzka_polnoc_v1, Mirko 21. 10.) — GPS sú dva body na úsek (ústava 121.4),
          takže pohyb po dni vidno z poradia úsekov: každý nový úsek nesie vlastnú štartovaciu polohu. */}
      {polohy && (() => {
        const useky = rows.filter(r => r.employee_id === sel && r.date === polohy.date).sort((a, b) => String(a.start_at || '').localeCompare(String(b.start_at || '')))
        const body = []
        useky.forEach(u => {
          if (u.start_lat) body.push({ cas: u.start_at, kde: `${u.start_lat},${u.start_lng}`, co: 'príchod', zak: u.project_name, rucne: u.rucne })
          if (u.end_lat) body.push({ cas: u.end_at, kde: `${u.end_lat},${u.end_lng}`, co: 'odchod', zak: u.project_name, polnoc: u.polnoc })
          else if (u.end_at) body.push({ cas: u.end_at, kde: '', co: u.polnoc ? 'zastavené o polnoci' : 'odchod', zak: u.project_name, polnoc: u.polnoc })
        })
        return (
          <Modal open onClose={() => setPolohy(null)} title={`Kedy sa zmenila poloha — ${polohy.meno || ''}`} maxWidth={620}
            subtitle={`${fmtD(polohy.date)} · poloha sa ukladá pri príchode a odchode, nie počas dňa (ústava 121.4)`}
            footer={<BtnGhost onClick={() => setPolohy(null)}>Zavrieť</BtnGhost>}>
            {body.length === 0
              ? <div style={{ color: COLORS.muted, fontSize: TYPO.sizes.sm }}>V tento deň nie je uložená žiadna poloha — zápis bol ručný alebo telefón polohu nepovolil.</div>
              : <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
                  <thead><tr style={{ background: COLORS.bgSoft }}>
                    {['Čas', 'Čo', 'Zákazka', 'Poloha'].map(h => <th key={h} style={{ fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '.05em', color: COLORS.muted, textAlign: 'left', padding: '5px 8px', borderBottom: `1px solid ${COLORS.line}` }}>{h}</th>)}
                  </tr></thead>
                  <tbody>
                    {body.map((x, i) => (
                      <tr key={i} style={{ background: x.polnoc ? POLNOC_BG : 'transparent' }}>
                        <td style={{ padding: '5px 8px', fontFamily: TYPO.mono, borderBottom: `1px solid ${COLORS.lineSoft}` }}>{x.cas || '—'}</td>
                        <td style={{ padding: '5px 8px', borderBottom: `1px solid ${COLORS.lineSoft}`, color: x.polnoc ? POLNOC_FG : COLORS.text, fontWeight: x.polnoc ? TYPO.weights.bold : TYPO.weights.normal }}>{x.co}</td>
                        <td style={{ padding: '5px 8px', borderBottom: `1px solid ${COLORS.lineSoft}` }}>{x.zak || '—'}</td>
                        <td style={{ padding: '5px 8px', borderBottom: `1px solid ${COLORS.lineSoft}` }}>
                          {x.kde
                            ? <a href={`https://maps.google.com/?q=${x.kde}`} target="_blank" rel="noreferrer" style={{ color: COLORS.nav }}>ukázať na mape</a>
                            : <span style={{ color: COLORS.muted }}>bez polohy</span>}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>}
          </Modal>
        )
      })()}

      {/* RUČNÝ ZÁPIS DŇA — vybitý telefón, nechal ho doma, dodatočná oprava (Mirko 3.8.) */}
      {rucny && (
        <Modal open onClose={() => setRucny(null)} title="Pridať deň ručne" maxWidth={620}
          subtitle="Zápis bez GPS — v prehľade bude označený ako ručný, aby sa netváril ako pichačka z telefónu."
          footer={<><BtnGhost onClick={() => setRucny(null)}>Zrušiť</BtnGhost><BtnAdd onClick={ulozRucny}>Zapísať deň</BtnAdd></>}>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))', gap: SPACE.md }}>
            <label style={{ display: 'block' }}>
              <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em' }}>Zamestnanec *</span>
              <SearchableSelect value={rucny.employee_id} onChange={v => setRucny(s2 => ({ ...s2, employee_id: v }))} menuPortal
                options={ludia.map(l => ({ value: l.id, label: l.meno }))} placeholder="Hľadať hodinovkára…" />
            </label>
            <label style={{ display: 'block' }}>
              <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em' }}>Zákazka *</span>
              <SearchableSelect value={rucny.project_id} onChange={v => setRucny(s2 => ({ ...s2, project_id: v }))} menuPortal
                options={projekty.map(p2 => ({ value: p2.id, label: (p2.zakazka_code ? p2.zakazka_code + ' · ' : '') + (p2.name || p2.id) }))}
                placeholder="Hľadať zákazku…" />
            </label>
            <label style={{ display: 'block' }}>
              <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em' }}>Dátum *</span>
              <input type="date" value={rucny.date} onChange={e => setRucny(s2 => ({ ...s2, date: e.target.value }))}
                style={{ ...inpSm, width: '100%', textAlign: 'left', padding: '7px 10px' }} />
            </label>
            <div style={{ display: 'flex', gap: SPACE.sm }}>
              <label style={{ flex: 1 }}>
                <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em' }}>Od</span>
                <input value={rucny.start_at} onChange={e => setRucny(s2 => ({ ...s2, start_at: e.target.value }))} placeholder="07:00" style={{ ...inpSm, width: '100%', textAlign: 'left', padding: '7px 10px' }} />
              </label>
              <label style={{ flex: 1 }}>
                <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em' }}>Do</span>
                <input value={rucny.end_at} onChange={e => setRucny(s2 => ({ ...s2, end_at: e.target.value }))} placeholder="15:30" style={{ ...inpSm, width: '100%', textAlign: 'left', padding: '7px 10px' }} />
              </label>
            </div>
            <div style={{ display: 'flex', gap: SPACE.sm }}>
              <label style={{ flex: 1 }}>
                <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em' }}>Obed od</span>
                <input value={rucny.lunch_od} onChange={e => setRucny(s2 => ({ ...s2, lunch_od: e.target.value }))} placeholder="11:30" style={{ ...inpSm, width: '100%', textAlign: 'left', padding: '7px 10px' }} />
              </label>
              <label style={{ flex: 1 }}>
                <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em' }}>Obed do</span>
                <input value={rucny.lunch_do} onChange={e => setRucny(s2 => ({ ...s2, lunch_do: e.target.value }))} placeholder="12:00" style={{ ...inpSm, width: '100%', textAlign: 'left', padding: '7px 10px' }} />
              </label>
            </div>
            <label style={{ display: 'block', gridColumn: '1 / -1' }}>
              <span style={{ fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.bold, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em' }}>Popis (nepovinné)</span>
              <input value={rucny.note} onChange={e => setRucny(s2 => ({ ...s2, note: e.target.value }))}
                placeholder="napr. vybitý telefón — nahlásil predák" style={{ ...inpSm, width: '100%', textAlign: 'left', padding: '7px 10px' }} />
            </label>
          </div>
        </Modal>
      )}
    </div>
  )
}
